import { backendUrl } from "../config/env";

let eventSource = null;

export function connectNotificationSSE(onMessage, onError) {
    const tokenType = localStorage.getItem("token-type");
    let token;

    if (tokenType === "Keycloak") {
        token = localStorage.getItem("keycloakToken");
    } else {
        const user = JSON.parse(localStorage.getItem("user"));
        token = user && user.token;
    }

    if (!token) {
        console.warn("Token tidak ada, SSE dibatalkan");
        return;
    }

    const url = `${backendUrl}/notifications/stream?token=${token}&type=${tokenType}`;

    eventSource = new EventSource(url);

    eventSource.onmessage = (event) => {
        try {
            const data = JSON.parse(event.data);
            onMessage && onMessage(data);
        } catch (err) {
            console.error("SSE parse error", err);
        }
    };

    eventSource.onerror = (err) => {
        console.error("SSE error", err);
        onError && onError(err);
    };
}

export function closeNotificationSSE() {
    if (eventSource) {
        eventSource.close();
        eventSource = null;
    }
}
